import React from 'react'
import './Enquiry_Component.css'
import Common_Enquiry_Form from '../../Common_Component/Common_Enquiry_Form/Common_Enquiry_Form'
import { Link } from 'react-router-dom'

const Enquiry_Component = () => {
  return (
    <section className='Enquiry_Component'>
      <div className='row'>

        <div className='col-xl-8 col-lg-7'>
          <div className='term_div'>
            <div className='img_holder'>
              <img src='\assets\Image\Blogs\term.png' className='term_img' />
            </div>

            <p className='main_text'>Term Insurance</p>
            <p className='subtext_p'>Explore our thoughtfully curated articles, tailored to help you make well-informed decisions about term insurance. We carefully select content with your needs in mind, empowering you to choose the right coverage for a secure future.</p>

            <div className='fotter_section'>
              <div className=''>
                <Link to={"/blog-details"}>
                  <p className='read_more_text'>
                    READ MORE
                  </p>
                </Link>
              </div>

              <div className=''>
                <p className='time_text'>
                  2 hrs ago
                </p>
              </div>
            </div>

          </div>
        </div>

        <div className='col-xl-4 col-lg-5'>
          <div className='blog_enquiry_form_div'>
            <Common_Enquiry_Form />
          </div>
        </div>

      </div>
    </section>
  )
}

export default Enquiry_Component
